import isInLengthValidatorUtil from '../../../../redux/utils/validate/validators/is-in-length'

function titlePostValidator (value) {
  return isInLengthValidatorUtil({
    key: 'title',
    name: 'Title',
    max: 60,
    min: 1,
    value
  })
}

export {
  titlePostValidator
}
